var map = {
	"./bedroom.svg": "f199",
	"./bookcase.svg": "b218",
	"./carriage-room.svg": "74eb",
	"./chest-of-drawers.svg": "75fa",
	"./corridor.svg": "82ef",
	"./desk.svg": "e2ef",
	"./living-room.svg": "626c",
	"./long-cupboard.svg": "9767",
	"./sofa.svg": "a0f8",
	"./tv-cupboard.svg": "6e41",
	"./wardrobe.svg": "0666"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c123";